import { required, maxLength } from 'vuelidate/lib/validators'
import Big from 'big.js'

export const caseCounts = (value) => {
  Big.DP = 5 // Decimal places
  Big.RM = 3 // Rounding mode Round up

  // let units = new Big(Math.ceil((units * 5) * 100000) / 100000).toFixed(5)
  let units = new Big(value * 5)

  if (units.eq(0)) {
    var caseUnits = new Big(0)
  } else if (units.lte(75)) { // Can't have a case smaller than 75
    var caseUnits = new Big(75)
  } else if (units.lte(125)) { // Next is 125
    var caseUnits = new Big(125)
  } else if (units.lte(150)) {
    var caseUnits = new Big(150)
  } else if (units.lte(200)) { // Skipping over 175 to 200 because there's no valid combination that yields 175
    var caseUnits = new Big(200)
  } else if (units.gt(new Big(200))) { // Now we have a usable case count every 25 units
    var caseUnits = (units.round(0, 1).mod(new Big(25)).eq(new Big(0))) ? units.round(0, 1) : units.plus(new Big(25)).div(new Big(2)).div(new Big(25)).round(0, 1).mul(new Big(25))
  }
  return caseUnits.eq(units)
}

export const hasSpecialCharacter = (value) => /(?=.[!@#\$%\^&])/.test(value)
export const hasLowercase = (value) => /(?=.*[a-z])/.test(value)
export const hasUppercase = (value) => /(?=.*[A-Z])/.test(value)
export const hasNumeric = (value) => /(?=.*[0-9])/.test(value)
export const itemExists = function (value) {
  return value && this.items && this.items.length && this.items.find((item) => (item.item_code === value) ? true : false)
}
export const validQuantity = (value) => true // TODO: Build out logic
export const passesApiValidation = function (param) {
  return function (value) {
    return ! this.failedApiValidation(param)
  }
}
